import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../index.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Upload() {
  const navigate = useNavigate();
  const [file, setFile] = useState();
  const [msg, setMsg] = useState(null);

  // category name
  const name = useParams()

  const handleDrop = (event) => {
    event.preventDefault();
    let files = event.dataTransfer.files;
    if (files.length > 0) {
      setFile(files[0]);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragStart = (event) => {
    event.dataTransfer.setData("text/plain", event.target.id);
  };

  const inputFile = useRef(null);

  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleUpload = async (e) => {
    // 1. Added async
    e.preventDefault();

    if (!file) {
      setMsg("No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setMsg("Uploading...");

      const response = await fetch(
        `https://oraserver.online/image/upload`, //filename {name}
        {
          method: "POST",
          body: formData,
          credentials : "include"
        },
       
      );

      if (response.ok) {
        navigate(`/profile`);
      } else {
        setMsg("Upload failed on server.");
      }
    } catch (error) {
      console.log("Error upload image : ", error);
      setMsg("Error Uploading file.");
    }
  };

  return (
    <>
      <Navbar />
      <div className="App">
        <div className="image">
          <h1>Upload your file</h1>
          <p>File should be Jpeg, Png...</p>
          <div
            className="image__box"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div
              className="image__box-icon"
              draggable="true"
              onDragStart={handleDragStart}
            >
              <img src="image.svg" alt="" />
            </div>
          </div>
          <p className="or">Or</p>

          <input
            type="file"
            name="file"
            onChange={(e) => setFile(e.target.files[0])}
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
          />
          <button onClick={onButtonClick} className="choose_file-btn">
            Choose a file
          </button>

          <button className="upload__button" onClick={handleUpload}>
            Upload
          </button>

          {msg && <span>{msg}</span>}
          {file && <span className="filename">{file.name}</span>}
        </div>
      </div>
      <Footer/>
    </>
  );
}
